var map = {
	"./symbols/left_arrow.svg": 1168,
	"./symbols/left_arrow_disabled.svg": 8294,
	"./symbols/multiply.svg": 7572,
	"./symbols/red_multiply.svg": 1139,
	"./symbols/right_arrow.svg": 9557,
	"./symbols/right_arrow_disabled.svg": 4814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9866;